export default class Message {
    message: String;
    typeId: Number;
    id: Number;

    constructor(id: Number, message: String, typeId: Number) {
        this.id = id;
        this.message = message;
        this.typeId = typeId;
    }

    getMessage () {
        return this.message;
    }

    getType () {
        return this.typeId;
    }

    getId() {
        return this.id;
    }

    static createFromJson(json: any) {
        return new Message(json.id, json.message, json.type_id);
    }
}


// WEBPACK FOOTER //
// ./src/Models/Message.ts